module.exports = new __parcel__URL__("Charlie_Display-Semibold.8fc988b4.woff").toString();